if (!customElements.get('carousel-gift-wrap')) {
  class CarouselGiftWrap extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.toggle = this.querySelector('[data-gift-wrap-toggle]');
      this.options = this.querySelector('[data-gift-wrap-options]');
      this.status = this.querySelector('[data-gift-wrap-status]');
      this.rail = this.querySelector('[data-gift-wrap-choices]');
      this.choices = Array.from(this.querySelectorAll('[data-gift-wrap-choice]'));
      this.defaultChoice = this.querySelector('[data-gift-wrap-default]');
      this.packingChoices = Array.from(this.querySelectorAll('[data-gift-wrap-packing-choice]'));
      this.defaultPackingChoice = this.querySelector('[data-gift-wrap-packing-default]');
      this.hasMultipleItems = this.dataset.hasMultipleItems === 'true';

      if (!this.toggle || !this.options || !this.status || this.choices.length === 0) return;

      this.toggle.addEventListener('change', () => this.handleToggle());
      this.choices.forEach(choice => choice.addEventListener('change', () => this.handleChoice(choice)));
      this.packingChoices.forEach(choice => choice.addEventListener('change', () => this.handlePackingChoice(choice)));
      this.syncFrom(this.dataset.currentValue || '', this.dataset.currentPacking || '');
    }

    handleToggle() {
      if (!this.toggle.checked) {
        this.options.hidden = true;
        this.persist('', '');
        return;
      }

      this.options.hidden = false;
      const selected = this.choices.find(choice => choice.checked) || this.defaultChoice;
      if (selected) selected.checked = true;
      const packing = this.getPackingValue();
      this.persist(selected?.value || 'Alege echipa Carousel', packing);
    }

    handleChoice(choice) {
      if (!choice.checked) return;
      this.toggle.checked = true;
      this.options.hidden = false;
      this.revealChoice(choice, true);
      this.persist(choice.value, this.getPackingValue());
    }

    handlePackingChoice(choice) {
      if (!choice.checked) return;
      this.toggle.checked = true;
      this.options.hidden = false;
      const selected = this.choices.find(option => option.checked) || this.defaultChoice;
      if (selected) selected.checked = true;
      this.persist(selected?.value || 'Alege echipa Carousel', choice.value);
    }

    getPackingValue() {
      if (!this.hasMultipleItems) return '';
      return this.packingChoices.find(choice => choice.checked)?.value
        || this.defaultPackingChoice?.value
        || 'Împreună, într-un singur cadou';
    }

    async persist(value, packingValue = '') {
      const previousValue = this.dataset.currentValue || '';
      const previousPackingValue = this.dataset.currentPacking || '';
      this.setBusy(true);
      this.dataset.error = 'false';

      try {
        const updateUrl =
          typeof routes !== 'undefined' && routes.cart_update_url
            ? routes.cart_update_url
            : `${window.Shopify?.routes?.root || '/'}cart/update.js`;
        const response = await fetch(updateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              [this.dataset.attributeKey || 'Ambalaj cadou']: value,
              [this.dataset.packingAttributeKey || 'Pregătire cadou']: value ? packingValue : ''
            }
          })
        });

        if (!response.ok) throw new Error(`Cart update failed with ${response.status}`);
        await response.json();

        document.querySelectorAll('carousel-gift-wrap').forEach(selector => selector.syncFrom(value, packingValue));
        const packingAnnouncement = packingValue ? ` ${packingValue}.` : '';
        this.announce(value ? `Ambalajul cadou a fost salvat: ${value}.${packingAnnouncement}` : 'Ambalajul cadou a fost eliminat.');
      } catch (error) {
        document.querySelectorAll('carousel-gift-wrap').forEach(selector => selector.syncFrom(previousValue, previousPackingValue));
        this.dataset.error = 'true';
        this.announce('Nu am putut salva alegerea. Încearcă din nou.', true);
        console.error(error);
      } finally {
        this.setBusy(false);
      }
    }

    syncFrom(value, packingValue = '') {
      this.dataset.currentValue = value;
      this.dataset.currentPacking = packingValue;
      const enabled = Boolean(value);
      if (this.toggle) this.toggle.checked = enabled;
      if (this.options) this.options.hidden = !enabled;

      let matched = false;
      this.choices?.forEach(choice => {
        choice.checked = enabled && choice.value === value;
        if (choice.checked) matched = true;
      });

      if (enabled && !matched && this.defaultChoice) this.defaultChoice.checked = true;
      if (!enabled && this.defaultChoice) this.defaultChoice.checked = true;

      let packingMatched = false;
      this.packingChoices?.forEach(choice => {
        choice.checked = enabled && choice.value === packingValue;
        if (choice.checked) packingMatched = true;
      });

      if (enabled && !packingMatched && this.defaultPackingChoice) this.defaultPackingChoice.checked = true;
      if (!enabled && this.defaultPackingChoice) this.defaultPackingChoice.checked = true;

      const selected = this.choices?.find(choice => choice.checked);
      if (enabled && selected) this.revealChoice(selected, false);
    }

    revealChoice(choice, smooth) {
      if (!this.rail || !choice) return;
      window.requestAnimationFrame(() => {
        const card = choice.closest('.carousel-gift-wrap__choice');
        if (!card) return;

        const target = Math.max(0, card.offsetLeft - this.rail.offsetLeft - 2);
        this.rail.scrollTo({ left: target, behavior: smooth ? 'smooth' : 'auto' });
      });
    }

    setBusy(isBusy) {
      this.setAttribute('aria-busy', String(isBusy));
      this.querySelectorAll('input').forEach(input => {
        input.disabled = isBusy;
      });

      document.querySelectorAll('[data-begin-checkout]').forEach(button => {
        if (isBusy && !button.disabled) {
          button.dataset.giftWrapPending = 'true';
          button.disabled = true;
          button.setAttribute('aria-disabled', 'true');
          return;
        }

        if (!isBusy && button.dataset.giftWrapPending === 'true') {
          delete button.dataset.giftWrapPending;
          if (!button.hasAttribute('data-checkout-blocked')) {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          }
        }
      });
    }

    announce(message, assertive = false) {
      if (!this.status) return;
      this.status.setAttribute('aria-live', assertive ? 'assertive' : 'polite');
      this.status.textContent = '';
      window.requestAnimationFrame(() => {
        this.status.textContent = message;
      });
    }
  }

  customElements.define('carousel-gift-wrap', CarouselGiftWrap);
}
